import { type ElementType, type ReactElement } from "react";

import { styled, cx } from "simplydo/react/styled";

import { StyledGroup } from "./Form.styles";
import type { FormGroupProps } from "./Form.types";

const FormGroupComponent = (props: FormGroupProps): ReactElement => {
  const {
    as,
    children,
    className,
    style,
    disabled,
    error,
    grouped,
    inline,
    widths,
  } = props;
  const Component = (as || "div") as ElementType;
  return (
    <StyledGroup
      as={Component}
      className={cx(
        className,
        widths === "equal" && "is-equal-width",
        inline && "is-inline",
        grouped && "is-grouped",
        disabled && "is-disabled",
        error && "is-error",
      )}
      style={style}
      $inline={inline}
    >
      {children}
    </StyledGroup>
  );
};

export const FormGroup = styled(FormGroupComponent)``;
